<cll-dialog-layout>
    <cll-dialog-header>
        <cll-dialog-title>Edit Priority</cll-dialog-title>
        <cll-dialog-subtitle>For {{ data.priority.name }}</cll-dialog-subtitle>
    </cll-dialog-header>
    <div class="dialog-detail">
        <div class="grid-columns-2">
            <cll-form-field label="Priority name">
                <input cllFormInput [formControl]="priorityFormGroup.controls.name" type="text">
            </cll-form-field>
            <cll-form-field label="Delay (in minutes)">
                <input cllFormInput
                       [formControl]="priorityFormGroup.controls.delay"
                       type="number"
                       min="0"
                       max="10080"
                >
                <cll-number-control
                    cllFormFieldControl
                />
            </cll-form-field>
        </div>
        <cll-form-field label="Description">
            <textarea cllFormInput [formControl]="priorityFormGroup.controls.description" type="text"></textarea>
        </cll-form-field>
    </div>
    <span class="dialog-divider"></span>
    <cll-dialog-footer>

        @if (editPriorityRequest.error(); as error) {
            <app-error-panel [error]="error" />
        }

        <button cll-button
                colour="variant"
                cllDialogClose>
            Cancel
        </button>
        <button cll-filled-button
                colour="secondary"
                [disabled]="priorityFormGroup.invalid || this.editPriorityRequest.loading()"
                (click)="edit()">
            Save
        </button>
    </cll-dialog-footer>
</cll-dialog-layout>
